module.exports = __webpack_public_path__ + "static/media/laser-ship.d56db7e1.svg";